import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { EditPackageTargetInstallationsReqData } from "./EditPackageTargetInstallationsReqData";

const ENDPOINT = "/device_update/package";

export class EditPackageTargetInstallationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "patch";
    reqData: EditPackageTargetInstallationsReqData;

    constructor(reqData: EditPackageTargetInstallationsReqData) {
        super();
        this.reqData = reqData;
    }

    public async execute(): Promise<AxiosResponse> {
        let res = await this.executeCommand(this.reqData);
        return res;
    }
}
